import {
    CUT_REGISTRATION_SAVE_REQ,
    CUT_REGISTRATION_SAVE_REQ_FAIL,
    CUT_REGISTRATION_SAVE_REQ_SUCCESS
} from "./cutRegistrationTypes";

const initialState = {
    registrationModelData: {},
    error : {},
    message: null,
    loading: false
}

const cutRegistrationReducer = (state = initialState, action) => {

    switch (action.type) {
        case CUT_REGISTRATION_SAVE_REQ:
            return {
                ...state,
                registrationModelData: {},
                error: {},
                loading: true,
                message: 'Sending data to save'

            };
        case CUT_REGISTRATION_SAVE_REQ_SUCCESS:
            return {
                ...state,
                registrationModelData: action.payload,
                error: {},
                loading: false,
                message: 'Data saved Successfully'
            };
        case CUT_REGISTRATION_SAVE_REQ_FAIL:
            return {
                ...state,
                registrationModelData: {},
                error: action.payload,
                loading: false,
                message: 'Error occurred while saving registration data'
            };
        default:
            return state;

    }
}

export default cutRegistrationReducer
